import React from 'react';

import {useTheme} from '@mui/material';
import {NotificationsEnum} from 'presentation/constants';
import Icon from 'presentation/icons';
import {useNotifications} from 'presentation/pages/private/notifications-area/hooks/useNotifications';
import {useNavigate} from 'react-router-dom';
import {StyledBadge, StyledNotificationsButton} from './styles';
import {useNotificationsStore} from 'presentation/pages/private/notifications-area/store/notificationStore';
import {translations} from 'presentation/translations-new';

const {notifications} = translations['pt-br'].commons;

export function NotificationsButton() {
	const navigate = useNavigate();
	const theme = useTheme();

	const isNotificationRead = useNotificationsStore(state => state.isRead);

	const handleNavigate = () => {
		navigate(NotificationsEnum.NOTIFICATIONS);
	};

	const {notificationsList} = useNotifications();

	const notificationsCount = notificationsList.reduce((count, notification) => {
		const isVisible = notification.shouldShow;
		const isRead = isNotificationRead(notification.id);

		return isVisible && !isRead ? count + 1 : count;
	}, 0);

	return (
		<StyledBadge color="error" overlap="circular" badgeContent={notificationsCount}>
			<StyledNotificationsButton
				onClick={handleNavigate}
				sx={{
					border:
						notificationsCount > 0 ? `2px solid ${theme.palette.error.main}` : 'none',
					p: notificationsCount > 0 ? '7px' : '9px',
				}}
				aria-label={notifications}>
				<Icon name="notifications-filled" size={24} fill={theme.palette.common.white} />
			</StyledNotificationsButton>
		</StyledBadge>
	);
}
